'use client'

import { ChevronDown, Search, UtensilsCrossed } from 'lucide-react'
import { useState } from 'react'
import { LocationCombobox } from './location-combobox'
import { GuestStepper, ReservationDatePicker, ReservationTimePicker } from './reservation-controls'

export function HeroSearch({ market, locationOptions }: { market: string; locationOptions: string[] }) {
  const [date, setDate] = useState(tomorrowDate)
  const [time, setTime] = useState('')
  const [partySize, setPartySize] = useState(2)

  return (
    <form className="hero-search" action="/search" method="get" aria-label="Search reservations">
      <label className="search-segment search-segment--type">
        <UtensilsCrossed size={18} />
        <span><small>Experience</small><select aria-label="Reservation type" name="type" defaultValue="dine-in"><option value="dine-in">Dine in</option></select></span>
        <ChevronDown className="segment-chevron" size={14} />
      </label>
      <LocationCombobox className="search-segment search-segment--location" value={market} suggestions={locationOptions} />
      <div className="search-segment search-segment--date">
        <ReservationDatePicker className="search-segment-control" name="date" value={date} min={todayDate()} onChange={setDate} />
      </div>
      <div className="search-segment search-segment--time"><ReservationTimePicker className="search-segment-control" name="time" value={time} onChange={setTime} includeAnyTime /></div>
      <GuestStepper className="search-segment search-segment--party" label="Party" name="partySize" value={partySize} max={12} onChange={setPartySize} />
      <button className="search-submit" type="submit">
        <Search size={19} />
        <span>Find a table</span>
      </button>
    </form>
  )
}

function todayDate() {
  const date = new Date()
  return toLocalDate(date)
}

function tomorrowDate() {
  const date = new Date()
  date.setDate(date.getDate() + 1)
  return toLocalDate(date)
}

function toLocalDate(date: Date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
